import styled from "@emotion/styled"
import Link from "components/Link"

const ArticleAuthorPhotoLink = styled(Link)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
`
export default ArticleAuthorPhotoLink
